import type { GatewayAssetOut } from "kubb";

/**
 * Case- and whitespace-agnostic Elvaco check, tolerant of vendor suffixes
 * like "Elvaco AB". Mirrors the backend `GatewayAsset.is_elvaco` predicate
 * so that observation-rewritten manufacturers still match.
 */
export const isElvacoManufacturer = (m?: string | null): boolean =>
  !!m && m.trim().toLowerCase().startsWith("elvaco");

/** True for an Elvaco-built Edge gateway. Mirrors backend `is_edge`. */
export const isEdgeGateway = (
  g: Pick<GatewayAssetOut, "manufacturer" | "model">,
): boolean => isElvacoManufacturer(g.manufacturer) && g.model === "Edge";
